import React, { useState } from "react";
import { toast } from "react-toastify";

const SelectCard = ({ paymentCardsData, setBookingStatus, handlePayment, cardLoader }) => {
    const cards = Array.isArray(paymentCardsData) ? paymentCardsData : [];

    const defaultCard = cards.find((card) => card.defaultCard) || null;

    const [selected, setSelected] = useState(
        defaultCard ? defaultCard : null
    );

    const onConfirm = () => {
        if (!defaultCard) {
            return toast.error(`Please add your card`);
        }
        handlePayment(selected)
    };

    return (
        <div
            className="bg-white rounded-xl w-96 p-4 relative"
            onClick={(e) => e.stopPropagation()}
        >
            {/* Header */}
            <div className="flex items-center mb-4">
                <button
                    onClick={() => setBookingStatus(1)}
                    className="mr-3 text-gray-600 hover:text-black"
                >
                    ←
                </button>
                <h2 className="text-lg font-semibold">Select Card</h2>
                <button
                    onClick={() => setBookingStatus(0)}
                    className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center"
                >
                    ✕
                </button>
            </div>

            {/* Saved Cards */}
            {cards.map((card) => (
                <div
                    key={card.id}
                    onClick={() => setSelected(card)}
                    className={`border rounded-lg p-3 flex items-center gap-3 cursor-pointer mb-3
                    ${selected === card
                            ? "border-blue-500"
                            : "border-gray-200"
                        }`}
                >
                    <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                        💳
                    </div>

                    <div className="flex-1">
                        <p className="font-medium text-sm">
                            {card.cardHolderName}
                            {card.defaultCard && (
                                <span className="ml-2 text-xs text-blue-600">
                                    (Default)
                                </span>
                            )}
                        </p>
                        <p className="text-gray-500 text-xs">
                            {card.cardBrand} • **** {card.last4}
                        </p>
                        <p className="text-gray-400 text-xs">
                            Exp {card.exp_month}/{card.exp_year}
                        </p>
                    </div>
                </div>
            ))}

            {/* Add new payment method */}
            <p className="text-sm text-gray-500 mb-2 mt-4">
                Add new payment method
            </p>

            <div
                onClick={() => setBookingStatus(3)}
                className={`border rounded-lg p-3 flex items-center gap-3 cursor-pointer
                ${selected === "new"
                        ? "border-blue-500"
                        : "border-gray-200"
                    }`}
            >
                <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                    ➕
                </div>
                <p className="text-sm font-medium">Add Credit / Debit Card</p>
            </div>

            {/* Confirm Button */}
            <div className="mt-6">
                <button
                 disabled={cardLoader}
                    onClick={onConfirm}
                    className="w-full py-3 rounded-lg text-white font-semibold
                    bg-gradient-to-r from-indigo-600 to-blue-500"
                >
                    {cardLoader ? 'Loading...' : 'Confirm'}
                </button>
            </div>
        </div>
    );
};

export default SelectCard;